<template>
    <table class="table table-striped table-hover">
        <thead>
        <tr>
            <th v-for="column in columns" :key="column.name" @click="$emit('sort', column)"
                :class="column.sortable ? sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting' : ''"
                :style="'width:'+column.width+';cursor:' + (column.sortable ? 'pointer;' : 'not-allowed')">
                <span class="column_label">{{column.label}}</span>
            </th>
        </tr>
        </thead>
        <slot></slot>
        <tfoot>
        <tr>
            <th v-for="column in columns" :key="column.name" @click="$emit('sort', column)"
                :class="column.sortable ? sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting' : ''"
                :style="'width:'+column.width+';cursor:' + (column.sortable ? 'pointer;' : 'not-allowed')">
                <span class="column_label">{{column.label}}</span>
            </th>
        </tr>
        </tfoot>
    </table>
</template>

<script>
    export default {
        props: ['columns', 'sortKey', 'sortOrders']
    }
</script>
<style scoped>
    table{
        border-collapse: separate;
    }
    .column_label{
        padding-left: 15px;
    }
    .sorting {
        background-image: url("/assets/images/sort_both.png");
        background-repeat: no-repeat;
        background-position: center left;
    }
    .sorting_asc {
        background-image: url('/assets/images/sort_asc.png');
        background-repeat: no-repeat;
        background-position: center left;
    }
    .sorting_desc {
        background-image: url('/assets/images/sort_desc.png');
        background-repeat: no-repeat;
        background-position: center left;
    }
</style>
